<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <div v-if="isLoading" class="alert alert-info" role="status">{{$t('alerts.loading')}}...</div>
          <div v-if="error" class="alert alert-danger" role="alert">
            <span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ error }}
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <EXCMDevicePeripheralDeviceForm
                  :type="1"
                  :handle-submit="onSendForm"
                  :handle-update-field="updateField"
                  :values="item"
                  :errors="violations" />
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import EXCMDevicePeripheralDeviceForm from './Form'

const { mapGetters, mapActions } = createNamespacedHelpers('excmdeviceperipheraldevice/create')

export default {
  components: {
    EXCMDevicePeripheralDeviceForm
  },

  props: {
    deviceIRI: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      routeName: '',
      item: {}
    }
  },

  computed: mapGetters([
    'error',
    'isLoading',
    'created',
    'violations'
  ]),

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }
      if (this.routeName === 'EXCMDeviceShow') {
        this.$Swal({
          title: this.$t('notifications.created'),
          type: 'success'
        })
        this.$store.state.modals.excmdeviceperipheraldevice.create.created = 1
        this.$store.state.modals.excmdeviceperipheraldevice.create.close = 1
      } else {
        this.$router.push({ name: 'EXCMDevicePeripheralDeviceUpdate', params: { id: created['@id'] } })
      }
    }
  },

  created () {
    this.routeName = this.$route.name
    if (this.deviceIRI) {
      this.item.device = this.deviceIRI
    }
  },

  methods: {
    ...mapActions([
      'create'
    ]),

    onSendForm () {
      this.create(this.item)
    },

    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
